import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import { Control } from 'shared/components/fields/control';
import { ScanSerial } from 'entities/device.add/ui/serial/scan-serial';
import { TextInputWrapper } from 'shared/components/fields/text';
import { check_serial_crc, clean_serial } from 'entities/device.add/lib/serial-utils';
import { ColumnBox } from 'shared/components/containers';
import { useMutationCallback } from 'shared/api/hooks';
import { Add } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useBox } from 'shared/hooks/utils';
import { AddDeviceStep } from 'entities/device.add/model/type';
import { useAction } from 'shared/hooks/redux/hooks';
import { pickDevice } from 'console/redux/main-actions';
function validateSerial(serial) {
    const trimmed = serial.trim();
    if (trimmed.length === 0) {
        return 'Введите серийный номер';
    }
    const cleaned = clean_serial(trimmed);
    if (!cleaned.match(/^[0-9A-F]{12}$/)) {
        return 'Должно быть 12 знаков (цифр и букв от A до F)';
    }
    if (!check_serial_crc(cleaned)) {
        return 'Неверный номер, проверьте правильность ввода.';
    }
    return null;
}
export const SerialInput = memo(function SerialInput(props) {
    const { setNextStep, setDeviceId } = props;
    const [scanError, setScanError] = useState(null);
    const [serial, setSerial] = useState('');
    const boxedSerial = useBox(serial);
    const [validate_serial, setValidateSerial] = useState(null);
    const boxedValidateSerial = useBox(validate_serial);
    const onChangeSerial = useCallback((serial) => {
        setSerial(serial);
        if (boxedValidateSerial.current != null) {
            setValidateSerial(validateSerial(serial));
        }
    }, []);
    const [onAddDevice, loadingAddDevice, responseAddDevice, errorAddDevice, sendAddDevice,] = useMutationCallback('add_device');
    const _pickDevice = useAction(pickDevice);
    useEffect(() => {
        if (responseAddDevice?.ok && sendAddDevice) {
            setDeviceId(responseAddDevice.device.id);
            setNextStep(AddDeviceStep.AddSim);
            _pickDevice(responseAddDevice.device.id);
        }
    }, [responseAddDevice, sendAddDevice]);
    const onClickAddDevice = useCallback(() => {
        const valid = validateSerial(boxedSerial.current);
        if (valid !== null) {
            setValidateSerial(valid);
            return;
        }
        onAddDevice({
            serial: clean_serial(boxedSerial.current),
            timezone: Math.min(Math.max(parseInt('' + -new Date().getTimezoneOffset() / 60, 10), 0), 12),
            devtype: 'other',
            name: clean_serial(boxedSerial.current),
            dont_mark_as_dirty: [],
            only_check: false,
        });
    }, []);
    return (_jsxs(ColumnBox, { children: [_jsx(ScanSerial, { setSerial: setSerial, onError: setScanError }), _jsx(Control, { label: "\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440", value: serial, onChange: onChangeSerial, help_id: "wizard_serial", validation_result: validate_serial, validation_warnings_result: null, field: TextInputWrapper, helper_text: "12-\u0437\u043D\u0430\u0447\u043D\u0430\u044F \u0441\u0442\u0440\u043E\u043A\u0430, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u0430\u044F \u043D\u0430\u00A0\u043A\u043E\u0440\u043F\u0443\u0441\u0435, \u0432 \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0435 \u0438 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439\u043D\u043E\u043C \u0442\u0430\u043B\u043E\u043D\u0435", onComplete: onClickAddDevice }), _jsx(LoadingButton, { onClick: onClickAddDevice, startIcon: _jsx(Add, {}), variant: "contained", loading: loadingAddDevice, disabled: serial.trim().length == 0, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }), errorAddDevice && _jsxs(Alert, { severity: "error", children: [" ", errorAddDevice] }), scanError != null && _jsxs(Alert, { severity: "error", children: [" ", scanError] })] }));
});
